<template>
  <div>
    <Pie
      ref="chart"
      v-if="chartData && chartOptions"
      :chart-options="chartOptions"
      :chart-data="chartData"
      chart-id="pie-chart"
      :width="400"
      :height="400"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import { Pie } from 'vue-chartjs/legacy'

import Pptxgen from 'pptxgenjs'

import { getChartData, getChartOptions, exportChart } from './utils'

import { eventBus } from '@/main'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale)

export default {
  name: 'PieChart',

  props: {
    question_result: {
      required: true,
      type: Object,
    },

    colors: {
      required: true,
    },

    chartIndex: {
      required: true,
    },

    isPercent: {
      required: true,
    },

    isMatrix: {
      required: true,
    },

    question_result_index: {
      required: true,
    },
  },

  components: {
    Pie,
  },

  data() {
    return {
      chartOptions: null,
      chartData: null,
      pptLoader: false,
    }
  },

  computed: {
    ...mapGetters(['reportQuestionsDownloadControl']),

    results() {
      const results = this.isMatrix
        ? this.question_result?.results[this.chartIndex].subAnswers
        : this.question_result?.results

      return results
    },
  },

  watch: {
    colors() {
      this.setData()
    },
  },

  methods: {
    ...mapActions(['setReportQuestionsDownloadControl']),

    async exportPPT(index) {
      if (index !== this.question_result_index) return

      this.setReportQuestionsDownloadControl({
        ...this.reportQuestionsDownloadControl,

        [this.question_result_index]: !this.reportQuestionsDownloadControl[
          this.question_result_index
        ],
      })

      const exportSettings = {
        optionsSettings: {
          showLegend: true,
          showPercent: this.isPercent,
          showValue: !this.isPercent,
        },

        typeCharts: 'PIE',
      }

      exportChart(
        Pptxgen,
        this.results,
        this.isPercent,
        this.question_result,
        this.isMatrix,
        this.colors,
        this.chartIndex,
        exportSettings,
      )

      this.setReportQuestionsDownloadControl({
        ...this.reportQuestionsDownloadControl,

        [this.question_result_index]: !this.reportQuestionsDownloadControl[
          this.question_result_index
        ],
      })
    },

    setData() {
      const datasets = {
        borderWidth: 1,
      }

      this.chartData = getChartData(
        this.results,
        this.isMatrix,
        this.isPercent,
        this.colors,
        datasets,
      )
    },

    setOptions() {
      const optionsSettings = {
        plugins: {
          legend: {
            align: 'start',

            labels: {
              boxWidth: 10,
              boxHeight: 10,
            },
          },
        },
      }

      this.chartOptions = getChartOptions(this.isPercent, optionsSettings)
    },
  },

  mounted() {
    this.setOptions()
    this.setData()
  },

  created() {
    eventBus.$on('pieExportChart', index => {
      this.exportPPT(index)
    })
  },
}
</script>

<style lang="scss" scoped></style>
